// extracted by css-extract-rspack-plugin
export default {"ChecksStatusBadgeButton":"ChecksStatusBadge-module__ChecksStatusBadgeButton__vTwYt","ChecksStatusBadgeIconButton":"ChecksStatusBadge-module__ChecksStatusBadgeIconButton__rcQQ1"};